// extracted by mini-css-extract-plugin
module.exports = {"container":"KanaBox_container__2EXxu","gridBox":"KanaBox_gridBox__11xMz","titleBox":"KanaBox_titleBox__1qRqI","kana":"KanaBox_kana__ODvye"};